export const parseDataByDate = async ({ data, }) => {
  console.debug('SalesChart[getter][parseDataByDate]', data); //DELETE

  if (!data.salesToFavoritesRatio) {
    return null;
  }

  return data.salesToFavoritesRatio;
};